// removed by extract-text-webpack-plugin
module.exports = {"root":"PriceFilterPlain__root__3Bl2w","filterLabel":"PriceFilterPlain__filterLabel__1pTEc","filterLabelSelected":"PriceFilterPlain__filterLabelSelected__1k4Ip","labelButton":"PriceFilterPlain__labelButton__3rFPb","formWrapper":"PriceFilterPlain__formWrapper__2Bt8i","clearButton":"PriceFilterPlain__clearButton__2veuF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PriceFilter/PriceFilterPlain.css
// module id = 2054
// module chunks = 0